module.exports = __webpack_public_path__ + "img/logo_schenker.07dfad3e.png";